import { useContext } from 'react';
import { useStore } from 'zustand';
import SimInventoryStoreContext from './SimInventoryStoreContext';
import type { SimInventoryState } from './types';

function useSimInventoryStore<T>(selector: (state: SimInventoryState) => T): T {
  const store = useContext(SimInventoryStoreContext);
  if (!store) {
    throw new Error('Missing SimInventoryStoreProvider in the tree');
  }
  return useStore(store, selector);
}

export default useSimInventoryStore;
